

































import mixins from 'vue-typed-mixins';
export default mixins().extend({
  computed: {
    deployment() {
      const metas = document.getElementsByTagName('meta');
      for (const i in metas) {
        if (
          typeof metas[i] === 'object' &&
          metas[i]?.getAttribute('name') === 'deployment'
        ) {
          const content: any = metas[i]?.getAttribute('content');
          if (content) {
            return this.$translate(JSON.parse(content)?.name);
          }
        }
      }
    },
  },
});
